export const styleNodes = (nodes, color1, color2) => {
  return nodes.map((node) => ({
    ...node,
    style: {
      border: `2px solid ${color1}`,
      backgroundColor: color2,
      borderRadius: 8,
    },
  }));
};
